export function mapCatalogResourceResponseToStaffMember(resourceResponse) {
    const { resource, slugs } = resourceResponse;
    return {
        id: resource.id,
        name: resource.name,
        slug: slugs[0]?.name,
    };
}
//# sourceMappingURL=staff-member.mapper.js.map